import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate} from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Link as ScrollLink, Element, scroller } from 'react-scroll';

import logo from '../moodmealslogo.png';
import cart from "../assets/icons/Fast Cart.png";
import user1 from "../assets/icons/User.png";
import shape from "../assets/icons/Frame1.png";
import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";
import energize from "../assets/images/Energize.png";
import relax from "../assets/images/Relax.png";
import focus from "../assets/images/Focus.png";
import comfort from "../assets/images/Comfort.png";

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import '../styles/HomePage.css';

const HomePage=({user,onLogout,logoutSuccess,setLogoutSuccess})=>{

    const [isMenuOpen,setIsMenuOpen]=useState(false);
    const [isLoading,setIsLoading]=useState(false);
    const [isDropdownOpen,setIsDropdownOpen]=useState(false);
    const location=useLocation();
    const navigate=useNavigate();
    const dropdownRef=useRef(null);

    useEffect(()=>{
        if(logoutSuccess){
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                setLogoutSuccess(false);
                navigate('/');
            }, 2000);
        }
    },[logoutSuccess,navigate,setLogoutSuccess]);

    useEffect(()=>{
        if(location.state&&location.state.section){
            scroller.scrollTo(location.state.section,{
                duration: 500,
                delay: 0,
                smooth: 'easeInOutQuart'
            });
        }
    },[location]);

    const toggleMenu=()=>{
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleUser=()=>{
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleClickOutside=(e)=>{
        if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
            setIsDropdownOpen(false);
        }
    };

    useEffect(()=>{
        document.addEventListener('mousedown',handleClickOutside);
        return()=>{
            document.removeEventListener('mousedown',handleClickOutside);
        };
    },[]);

    const settings={
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
            breakpoint: 1024,
            settings: {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                initialSlide: 0,
                autoplay: true,
                autoplaySpeed: 3000,
            }},{
            breakpoint: 768,
            settings: {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 2,
                autoplay: true,
                autoplaySpeed: 3000
            }},{
            breakpoint: 320,
            settings: {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 0,
                autoplay: true,
                autoplaySpeed: 3000
            }}
        ]
    };

    return(
        <>
            {isLoading?(
                <div className="loadingContainer">
                    <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
                </div>
            ):(
            <>
                {/* <!-- Header / Navigation --> */}
                <header className="home-header">
                    <div className="home-wrapper">
                        <div className="home-sub-header">
                            <div className="home-dropdown-menu">
                                <button className="home-menu-toggle" onClick={toggleMenu}>
                                    ☰
                                </button>
                                <nav className="home-navbar">
                                    <ul className={`home-nav-links${isMenuOpen?'open':''}`}>
                                        <li><Link to="/" className="Link">Home</Link></li>
                                        <li><Link to="/shop" className="Link">Shop</Link></li>
                                        <li><ScrollLink to="recipes" className="Link" smooth={true} duration={500}>Recipes</ScrollLink></li>
                                        <li><ScrollLink to="community" className="Link" smooth={true} duration={500}>Community</ScrollLink></li>
                                        <li><ScrollLink to="about-us" className="Link" smooth={true} duration={500}>About Us</ScrollLink></li>
                                        <li><ScrollLink to="contact" className="Link" smooth={true} duration={500}>Contact</ScrollLink></li>
                                        <li><ScrollLink to="blog" className="Link" smooth={true} duration={500}>Blog</ScrollLink></li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="home-cart-user">
                                <Link to="/your-cart"><img className="home-cart" src={cart} alt="#" loading="lazy"/></Link>
                                <div className="userDropdown">
                                    <img className="home-user" src={user? user.avatar:user1} alt="#" loading="lazy" onClick={toggleUser}/>
                                    {isDropdownOpen&&(
                                        <div className="dropdownMenu" ref={dropdownRef}>
                                            {user?(
                                                <>
                                                    <p className="dropdownItem">Welcome, {user.firstname}</p>
                                                    <hr/>
                                                    {user.role==='Admin'&&(
                                                        <Link to="/admin" className="dropdownItem">Admin Panel</Link>
                                                    )}
                                                    <Link to="/your-orders" className="dropdownItem">Orders</Link>
                                                    <hr/>
                                                    <Link to="/profile" className="dropdownItem">Profile</Link>
                                                    <Link to="/setting" className="dropdownItem">Setting</Link>
                                                    <Link onClick={onLogout} className="dropdownItem">Log Out</Link>
                                                </>
                                            ):(
                                                <>
                                                    <Link to="/login" className="dropdownItem">Login</Link>
                                                    <Link to="/register" className="dropdownItem">Register</Link>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="home-flex">
                            <div className="home-hero-content">
                                {user?(
                                    <>
                                        <h1>Welcome {user.firstname}!<br/>Nourish Your Mood, One Bite at a Time</h1>
                                        <p>Personalized Meal Kits & Snacks Designed to Boost Your Emotions</p>
                                    </>
                                ):(
                                    <>
                                        <h1>Nourish Your Mood, One Bite at a Time</h1>
                                        <p>Personalized Meal Kits & Snacks Designed to Boost Your Emotions</p>
                                    </>
                                )}
                                <div className="home-hero-buttons">
                                    <Link to="/quiz" className="home-primary-btn">Take the Mood Quiz</Link>
                                    <Link to="/shop" className="home-secondary-btn">Shop Now</Link>
                                </div>
                            </div>
                            <div className="home-logo-wrapper">
                                <Link to="/"><img className="home-logo" src={logo} alt="MoodMeals Logo" loading="lazy"/></Link>
                            </div>
                        </div>
                    </div>
                </header>
                {/* <!-- How It Works Section --> */}
                <section className="home-wrapperbg">
                    <section className="home-mainsection">
                        <section id="home-how-it-works" className="home-section">
                            <h2>How It Works</h2>
                            <div className="home-steps-container">
                                <div className="home-step">
                                    <h3>1. Take Our Mood Quiz</h3>
                                    <p>Answer a few quick questions, and we'll suggest meals based on your emotional needs.</p>
                                </div>
                                <div className="home-step">
                                    <h3>2. Choose Your Meals or Snacks</h3>
                                    <p>Explore our curated, mood-boosting meal kits designed for relaxation, energy, focus, and more.</p>
                                </div>
                                <div className="home-step">
                                    <h3>3. Delivered to Your Door</h3>
                                    <p>Enjoy delicious, nourishing meals that match your mood, conveniently delivered.</p>
                                </div>
                            </div>
                            <Link to="/quiz" className="home-primary-btn">Start Quiz</Link>
                        </section>

                        {/* <!-- Shop by Mood Section --> */}
                        <section id="home-shop-by-mood" className="home-section">
                            <h2>Shop by Mood</h2>
                            <div className="home-mood-cards-container">
                                <Slider {...settings}>
                                    <div className="home-mood-card">
                                        <img src={energize} alt="Energize Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Energize</h3>
                                            <p>Boost your energy with meals that invigorate your mind and body.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Energize</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={relax} alt="Relax Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Relax</h3>
                                            <p>Calming meals to help you unwind and reduce stress.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Relax</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={focus} alt="Focus Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Focus</h3>
                                            <p>Stay sharp with meals designed for focus and concentration.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Focus</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={comfort} alt="Comfort Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Comfort</h3>
                                            <p>Warm, comforting meals to soothe your body and soul.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Comfort</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={energize} alt="Energize Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Energize</h3>
                                            <p>Boost your energy with meals that invigorate your mind and body.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Energize</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={relax} alt="Relax Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Relax</h3>
                                            <p>Calming meals to help you unwind and reduce stress.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Relax</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={focus} alt="Focus Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Focus</h3>
                                            <p>Stay sharp with meals designed for focus and concentration.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Focus</Link>
                                        </div>
                                    </div>
                                    <div className="home-mood-card">
                                        <img src={comfort} alt="Comfort Meals"/>
                                        <div className="home-mc-description">
                                            <h3>Comfort</h3>
                                            <p>Warm, comforting meals to soothe your body and soul.</p>
                                            <Link to="/shop" className="home-secondary-btn">Browse Comfort</Link>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </section>
                    </section>

                    {/* <!-- Customer Testimonials Section --> */}
                    <section className="home-mainsection2">
                        <section id="home-testimonials" className="home-section">
                            <h2>What Our Customers Are Saying</h2>
                            <div className="home-testimonials-container">
                                <blockquote>
                                    <p>"MoodMeals is a game-changer! I feel more energized throughout the day, and the recipes are amazing."</p>
                                    <cite>- Jessica D.</cite>
                                </blockquote>
                                <blockquote>
                                    <p>"I ordered the Relaxation Plan and it made my evenings much more peaceful. Delicious and convenient."</p>
                                    <cite>- Sarah J.</cite>
                                </blockquote>
                                <blockquote>
                                    <p>"The Energy Boost Plan gave me the fuel I needed to get through my busy workdays. Absolutely love the fresh ingredients!"</p>
                                    <cite>- David P.</cite>
                                </blockquote>
                            </div>
                        </section>
                        {/* <!-- Meal Kits Section --> */}
                        <section id="home-meal-kits" className="home-section">
                            <h2>Mood-Boosting Meal Kits</h2>
                            <div className="home-kits-container">
                                <div className="home-kit-card">
                                    <div className="home-promo-wrapper">
                                        <div className="home-promo">
                                            <p>₱2,998/week for the first month.</p>
                                        </div>
                                    </div>
                                    <div className="home-plan-wrapper">
                                        <div className="home-description">
                                            <h2>Weekly MoodBoost Plan</h2>
                                            <p>Feel your best every day with fresh, mood-boosting meals delivered to your door every week.</p>
                                        </div>
                                        <div className="home-get_bonus">
                                            <p><b>What You Get:</b></p>
                                            <ul>
                                                <li>4 to 6 curated meals per week based on your mood profile (Energize, Relax, Focus, or Comfort).</li>
                                                <li>Includes snacks and drinks matched to your emotional needs.</li>
                                                <li>Free recipe cards for additional mood-based meals.</li>
                                            </ul>
                                            <div className="home-bonus"><b>Bonus:</b> Access to exclusive wellness tips and discounts on extra snacks.</div>
                                        </div>
                                    </div>
                                    <div className="home-srp-btn">
                                        <div className="home-srp">
                                            <h2>P3,332/week</h2>
                                        </div>
                                        <div className="home-plan-btn">
                                            <button className="home-primary-btn">Subscribe to Weekly</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="home-kit-card">
                                    <div className="home-promo-wrapper">
                                        <div className="home-promo">
                                            <p>5% off for 2-month commitment, 10% off for 6-month.</p>
                                        </div>
                                    </div>
                                    <div className="home-plan-wrapper">
                                        <div className="home-description">
                                            <h2>Bi-Weekly Balance Plan</h2>
                                            <p>Find the perfect balance with meals delivered every two weeks to support your emotional wellness.</p>
                                        </div>
                                        <div className="home-get_bonus">
                                            <p><b>What You Get:</b></p>
                                            <ul>
                                                <li>6 to 8 meals delivered bi-weekly, carefully selected to balance your energy and emotions.</li>
                                                <li>A mix of comforting, energizing, and focusing meals, plus mood-enhancing snacks.</li>
                                                <li>Option to customize based on changing moods.</li>
                                            </ul>
                                            <div className="home-bonus"><b>Bonus:</b> Access to exclusive recipes and a wellness guide to track your emotional health.</div>
                                        </div>
                                    </div>
                                    <div className="home-srp-btn">
                                        <div className="home-srp">
                                            <h2>P6,108/bi-week</h2>
                                        </div>
                                        <div className="home-plan-btn">
                                            <button className="home-primary-btn">Subscribe to Bi-Weekly</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="home-kit-card">
                                    <div className="home-promo-wrapper">
                                        <div className="home-promo">
                                            <p>₱833 off the first box, up to 15% off for 6-month.</p>
                                        </div>
                                    </div>
                                    <div className="home-plan-wrapper">
                                        <div className="home-description">
                                            <h2>Monthly Mindful Plan</h2>
                                            <p>Nourish your body and mind with monthly deliveries of meals designed to support your emotions.</p>
                                        </div>
                                        <div className="home-get_bonus">
                                            <p><b>What You Get:</b></p>
                                            <ul>
                                                <li> 10 to 12 meals delivered once a month, carefully chosen for maximum emotional impact.</li>
                                                <li>Includes a special mood-enhancing snack box and a set of drinks like calming teas or energizing smoothies.</li>
                                                <li>A monthly mood tracker to record how different meals impact your feelings.</li>
                                            </ul>
                                            <div className="home-bonus"><b>Bonus:</b> Access to exclusive seasonal recipes and a MoodMeals journal to help you reflect on your mood-food journey.</div>
                                        </div>
                                    </div>
                                    <div className="home-srp-btn">
                                        <div className="home-srp">
                                            <h2>P11,105/month</h2>
                                        </div>
                                        <div className="home-plan-btn">
                                            <button className="home-primary-btn">Subscribe to Monthly</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </section>
                {/* <!-- Recipes & Wellness Tips Section --> */}
                <section className="home-mainsection">
                    <Element name="recipes">
                        <section id="home-tips" className="home-section">
                                <h2>Recipes & Wellness Tips</h2>
                                <div className="home-articles">
                                    <article>
                                        <h3>5 Comfort Foods to Boost Your Mood</h3>
                                        <p>We all have those days when we need a little extra comfort. Whether it’s stress, fatigue, or just a gloomy mood, the right food can lift your spirits. Here are five mood-boosting comfort foods that not only taste amazing but can also help brighten your day.</p>
                                        <ul>
                                            <li>1. Mac and Cheese Creamy, cheesy, and warm, mac and cheese is the ultimate comfort food. The combination of carbs and dairy releases serotonin, the "happy hormone," making you feel relaxed and satisfied.</li>
                                            <li>2. Dark Chocolate A little dark chocolate can go a long way in improving your mood. Rich in antioxidants and natural mood-boosters like caffeine and theobromine, it’s the perfect treat to fight off stress and fatigue.</li>
                                            <li>3. Chicken Soup There’s a reason chicken soup is the go-to remedy for feeling under the weather. Warm broth and tender chicken provide nutrients that can help reduce inflammation, while the soothing warmth makes you feel cozy inside.</li>
                                            <li>4. Bananas Packed with potassium and vitamin B6, bananas help regulate dopamine and serotonin levels, naturally boosting your mood. Their sweetness also satisfies cravings, keeping you content.</li>
                                            <li>5. Mashed Potatoes Creamy mashed potatoes offer more than just comfort; they’re rich in potassium and fiber, which support your heart health. The soft, buttery texture also triggers feelings of warmth and relaxation.</li>
                                        </ul>
                                    </article>
                                    <article>
                                        <h3>Energizing Breakfast for Busy Mornings</h3>
                                        <p>When your mornings are packed, you need a breakfast that fuels you for the day without slowing you down. Here are five quick and energizing breakfast ideas to keep you going strong, even on the busiest of mornings.</p>
                                        <ul>
                                            <li>1. Overnight Oats Prepare the night before and wake up to a ready-to-eat meal! Combine oats, milk (or yogurt), chia seeds, and your favorite toppings like fruit or nuts. It’s a fiber-rich, slow-burning breakfast that keeps you full and energized all morning.</li>
                                            <li>2. Avocado Toast Whole-grain toast topped with creamy avocado is a perfect mix of healthy fats and complex carbs. Add a poached egg for protein, and you’ve got a nutrient-packed meal to power you through the day.</li>
                                            <li>3. Smoothie A smoothie is a quick way to pack in fruits, veggies, and protein. Blend together spinach, banana, Greek yogurt, and a scoop of protein powder for a refreshing and energizing breakfast you can sip on the go.</li>
                                            <li>4. Greek Yogurt with Granola Greek yogurt is rich in protein, while granola adds crunch and fiber. Toss in some berries for added antioxidants and natural sweetness. This combo provides sustained energy and keeps you satisfied.</li>
                                            <li>5. Egg Muffins Whisk eggs with vegetables like spinach, bell peppers, and onions, pour into muffin tins, and bake. These protein-packed egg muffins can be made in advance and grabbed on your way out the door, making them a convenient, energizing breakfast.</li>
                                        </ul>
                                    </article>
                                    <article>
                                        <h3>How Nutrition Affects Your Emotions</h3>
                                        <p>The food you eat doesn't just fuel your body—it plays a significant role in shaping your emotions, too. Certain nutrients can influence how you feel, making your diet a powerful tool in managing mood and emotional well-being. Here’s how nutrition affects your emotions:</p>
                                        <ul>
                                            <li>1. Blood Sugar Stability When you eat refined carbs or sugary snacks, your blood sugar spikes and crashes, leading to mood swings, irritability, and fatigue. Foods high in fiber and complex carbs, like whole grains and vegetables, help stabilize your blood sugar, providing consistent energy and keeping your mood steady.</li>
                                            <li>2. Serotonin Production Serotonin is a key hormone that regulates mood and happiness. Foods rich in tryptophan, an amino acid found in turkey, eggs, and nuts, help boost serotonin levels in the brain. Consuming these foods can improve your mood and promote feelings of calm and contentment.</li>
                                            <li>3. Omega-3 Fatty Acids Omega-3s, found in fish like salmon and walnuts, are essential for brain health. These healthy fats have been shown to reduce symptoms of depression and anxiety by supporting neurotransmitter function and reducing inflammation in the brain.</li>
                                            <li>4. B-Vitamins B-vitamins, particularly B6, B9 (folate), and B12, play a critical role in mood regulation. These vitamins are found in leafy greens, eggs, and legumes. Low levels of B-vitamins have been linked to depression and mood disorders, making it important to include them in your diet.</li>
                                            <li>5. Hydration Even mild dehydration can affect your emotions, leading to fatigue, difficulty concentrating, and irritability. Drinking enough water throughout the day is essential for mental clarity and emotional balance.</li>
                                        </ul>
                                    </article>
                                </div>
                                <button className="home-secondary-btn">See More</button>
                        </section>
                    </Element>

                    {/* <!-- About Us Section --> */}
                    <Element name="about-us">
                        <section id="about-us" className="home-Us">
                            <section id="home-about-us" className="home-section">
                                <h2>About Us</h2>
                                <div className="home-our-mission">
                                    <div className="home-image-container">
                                        <img className="home-shape" src={shape} alt="Shape" />
                                        <div className="home-text-overlay">Our Mission:</div>
                                        <div className="home-text-overlay2">Food That Feels You</div>
                                    </div>
                                    <p>"At MoodMeals, we believe that food is more than just fuel—it’s an experience that can transform how you feel. Whether you're seeking comfort, energy, relaxation, or focus, we curate meals and snacks that align with your emotional needs. Our goal is to help you nourish your body and mind, one bite at a time."</p>
                                </div>
                                <div className="home-Us-description">
                                    <h3>Our Story</h3>
                                    <p>"MoodMeals was born out of a passion for wellness and the recognition that food plays a powerful role in shaping our emotions. Our team of nutritionists, chefs, and wellness experts has crafted a personalized approach to eating that matches your mood. We blend science with delicious flavors to deliver meals that don't just satisfy your hunger but elevate your emotional well-being."</p>
                                    <h3>Our Values</h3>
                                    <ul>
                                        <li><b>Personalization:</b> Every meal is uniquely tailored to your emotional and nutritional needs.</li>
                                        <li><b>Wellness-Driven:</b> We combine psychological insights and nutritional research to bring balance to your mind and body.</li>
                                        <li><b>Sustainability:</b> We focus on sourcing ingredients that are both healthy for you and the planet.</li>
                                        <li><b>Community-Centered:</b> We believe in building a community of mindful eaters who are passionate about wellness and emotional well-being.</li>
                                    </ul>
                                    <h3>Join Our Journey</h3>
                                    <p>"We invite you to explore the connection between food and mood with us. Whether you're looking for a quick snack or a full meal, MoodMeals is here to guide your emotional wellness through the power of nutrition."</p>
                                </div>
                            </section>
                        </section>
                    </Element>
                </section>

                {/* <!-- Footer Section --> */}
                <Element name="contact">
                    <footer className="home-footer">
                        <h3 className="home-get-in-touch">Get in Touch</h3>
                        <div className="home-footer-content">
                            <div className="home-footer-section">
                                <h3>Customer Support</h3>
                                <p>Email: <a href="/">support@moodmeals.com</a></p>
                                <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                                <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                                <h3>General Inquiries:</h3>
                                <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                                <h3>Partnership Opportunities:</h3>
                                <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
                            </div>
                            <div className="home-footer-section">
                                <h3>Quick Links</h3>
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/shop">Shop</Link></li>
                                    <li><ScrollLink to="recipes" smooth={true} duration={500}>Recipes</ScrollLink></li>
                                    <li><ScrollLink to="community" smooth={true} duration={500}>Community</ScrollLink></li>
                                    <li><ScrollLink to="about-us" smooth={true} duration={500}>About Us</ScrollLink></li>
                                    <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                                    <li><ScrollLink to="blog" smooth={true} duration={500}>Blog</ScrollLink></li>
                                </ul>
                            </div>
                            <div className="home-footer-section">
                                <h3>Customer Services</h3>
                                <ul>
                                    <li><a href="#contact-us">Contact Us</a></li>
                                    <li><a href="#faq">FAQ</a></li>
                                    <li><a href="#shipping&returns">Shipping & Returns</a></li>
                                    <li><a href="#terms&condition">Terms & Condition</a></li>
                                    <li><a href="#privacy">Privacy Policy</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="home-soc-med">
                            <div className="home-app-wrapper">
                                <img className="home-app" src={facebook} alt="facebook"/>
                                <img className="home-app" src={instagram} alt="instagram"/>
                                <img className="home-app" src={twitter} alt="twitter"/>
                                <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
                            </div>
                            <div className="home-copyright">
                                <p>&copy; 2024 MoodMeals. All rights reserved.</p>
                            </div>
                        </div>
                    </footer>
                </Element>
            </>
            )}
        </>
    )
}

export default HomePage;